import { useNavigate } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import '../Global/Style/OrderListByCarrier.css';
import { getContrastTextColor } from '../../utils/ColorUtils';

const OrderListByCarrier = ({ orders, loading = false }) => {
  const navigate = useNavigate();

  const grouped = orders.reduce((acc, order) => {
    const key = order.carrier?.id || 'sin-transportista';
    if (!acc[key]) acc[key] = { carrier: order.carrier, orders: [] };
    acc[key].orders.push(order);
    return acc;
  }, {});

  // Calculate total score
  const totalScore = orders.reduce((sum, order) => sum + (order.totalScore || 0), 0);

  const formatClient = (c) =>
    `${c?.name || ''} ${c?.lastName1 || ''}`.trim();

  const goToOrderDetail = (orderId) => {
    navigate(`/orders/${orderId}`);
  };

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '40px' }}>
        <Spinner animation="border" />
        <p style={{ marginTop: '10px' }}>Cargando pedidos...</p>
      </div>
    );
  }

  return (
    <div className="grouped-orders-vertical">
      
      {/* Total Score Summary */}
      {totalScore > 0 && (
        <div style={{
          backgroundColor: '#f8f9fa',
          border: '1px solid #dee2e6',
          borderRadius: '6px',
          padding: '12px 16px',
          marginBottom: '16px'
        }}>
          <span style={{ color: '#6c757d', fontSize: '14px' }}>Puntuación total: </span>
          <span style={{ fontWeight: '600', fontSize: '16px' }}>{totalScore} pts</span>
        </div>
      )}
      
      {Object.entries(grouped).map(([carrierId, group]) => (
        <div key={carrierId} className="carrier-block">
          <div className="carrier-orders">
            {group.orders.map(order => (
              <div
                key={order.id}
                className="order-card clickable"
                onClick={() => goToOrderDetail(order.id)}
                style={{ 
                  backgroundColor: group.carrier?.colourHex || '#f9f9f9', 
                  color: group.carrier?.colourHex ? getContrastTextColor(group.carrier.colourHex) : '#333' 
                }}
              >
                <div className="order-header">
                  <strong>{formatClient(order.client)}</strong> –  
                  CP: {order.address?.zipCode || 'N/A'} –  
                  Fecha de entrega: {new Date(order.deliveryDate).toLocaleDateString('es-ES')}
                </div>
                <ul className="product-list">
                  {/* Productos normales */}
                  {(order.items || []).map(item => (
                    <li key={item.id}>
                      {item.quantity}× {item.productPrice?.type?.typeName}
                      {item.productPrice?.model?.modelName && ` – ${item.productPrice.model.modelName}`}
                      {item.productPrice?.color?.colorName && ` – ${item.productPrice.color.colorName}`}
                      {item.productPrice?.size?.size && ` – ${item.productPrice.size.size}`} : 
                      {item.unitPrice?.toFixed(2)}€
                      {item.orderItemVariants?.length > 0 && (
                        <div
                          style={{
                            fontSize: '0.85em',
                            fontStyle: 'italic',
                            marginLeft: '10px'
                          }}
                        >
                          Variantes: {item.orderItemVariants.map(v => v.variant.name).join(', ')}
                        </div>
                      )}
                    </li>
                  ))}

                  {/* Productos especiales */}
                  {order.specialProducts?.length > 0 && (
                    <>
                      {order.specialProducts.map(sp => (
                        <li key={sp.id} className="special-item">
                          {sp.quantity}× {sp.description}
                          :  
                          {sp.price?.toFixed(2)}€
                        </li>
                      ))}
                    </>
                  )}

                  {order.mileage != null && (
                    <li className="mileage-info">
                      Kilometraje: {order.mileage} km – Coste: {order.mileageCost?.toFixed(2) || '0.00'}€
                    </li>
                  )}

                  <li className="total">
                    <strong>Total: {order.totalAmount?.toFixed(2) || '0.00'}€</strong>
                    {order.totalScore > 0 && (
                      <div style={{
                        fontSize: '12px',
                        color: 'rgba(0,0,0,0.6)',
                        marginTop: '2px',
                        fontStyle: 'italic'
                      }}>
                        📊 {order.totalScore} pts
                      </div>
                    )}
                  </li>
                </ul>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default OrderListByCarrier;
